var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
var SystemMessagesService = /** @class */ (function () {
    //http://content.harel-employers/_vti_bin/webapi/SystemMessages
    function SystemMessagesService(_httpClient) {
        this._httpClient = _httpClient;
        this._systemMessagesDic = {};
        this._url = environment.apiUrl;
    }
    SystemMessagesService.prototype.initilizeSystemMessages = function (systemCodes) {
        this.getMessages(systemCodes).subscribe();
        //console.log(this._systemMessagesDic);
    };
    SystemMessagesService.prototype.getMessages = function (systemCodes) {
        var _this = this;
        var missingSystemCodes = [];
        var alreadyCached = {};
        systemCodes.forEach(function (systemCode) {
            if (_this._systemMessagesDic[systemCode] == null) {
                missingSystemCodes.push(systemCode);
            }
            else
                alreadyCached[systemCode] = _this._systemMessagesDic[systemCode];
        });
        if (missingSystemCodes.length > 0) {
            var params_1 = new HttpParams();
            params_1 = params_1.append('returnDefault', 'false');
            missingSystemCodes.forEach(function (systemCode) {
                params_1 = params_1.append('msgCode', systemCode);
            });
            return this._httpClient.get(this._url, { params: params_1 })
                .map(function (dic) {
                if (missingSystemCodes.length == 1) {
                    _this._systemMessagesDic[missingSystemCodes[0]] = dic;
                    alreadyCached[missingSystemCodes[0]] = dic;
                    return alreadyCached;
                }
                else {
                    _this._systemMessagesDic = __assign({}, _this._systemMessagesDic, dic);
                    return __assign({}, dic, alreadyCached);
                }
            });
        }
        else {
            return Observable.create(function (observer) { return observer.next(_this._systemMessagesDic); });
        }
    };
    SystemMessagesService.prototype.getMessage = function (msgCode, fetch) {
        var _this = this;
        if (fetch === void 0) { fetch = true; }
        if (this._systemMessagesDic[msgCode] == null) {
            if (fetch) {
                var params = new HttpParams();
                params = params.append('returnDefault', 'false');
                params = params.append('msgCode', msgCode);
                this._httpClient.get(this._url, { params: params }).subscribe(function (msg) { return _this._systemMessagesDic[msgCode] = msg; });
            }
            return null;
        }
        else {
            return this._systemMessagesDic[msgCode];
        }
    };
    return SystemMessagesService;
}());
export { SystemMessagesService };
